<template>
  <div>
    <div @click="openPopupPayed()">
      <vs-button v-if="cellValue" size="small" color="success">Pagado</vs-button>
      <vs-button v-else size="small" color="warning">No pagado</vs-button>
    </div>
    <vs-popup :title="title" :active.sync="popupActive">
        <p> Marcar como
          <span v-if="cellValue" class="text-dark uppercase">no pagado</span>
          <span v-else class="text-dark uppercase">pagado</span>
        </p>
        <vs-button v-can="'change_panel_payed_content_display'" @click="changeStatePayed()" color="primary" type="filled" class="float-right">Cambiar</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@/../appConfig.js'

export default Vue.extend({
  data () {
    return {
      rowValue: null,
      cellValue: null,
      popupActive: false,
      title: null
    }
  },
  beforeMount () {
    this.cellValue = this.getValueToDisplay(this.params)
    this.rowValue = this.params.data
    this.title = `Pantalla ID: ${this.rowValue.display_id}, Empresa:  ${this.rowValue.company_name}`
  },
  methods: {
    // gets called whenever the user gets the cell to refresh
    refresh (params) {
      this.cellValue = this.getValueToDisplay(params)
    },

    openPopupPayed () {
      this.popupActive = !this.popupActive
    },

    getValueToDisplay (params) {
      return params.value
    },

    changeStatePayed () {
      this.$http.post(`${appConfig.apiUrl}/panel/content-display/${this.rowValue.content_display_id}/payed`, {
        params: {}
      })
        .then((response) => {
          this.cellValue = response.data.is_payed

          this.$vs.notify({
            title: this.title,
            text: `${this.cellValue ? 'PAGADO' : 'NO PAGADO'}`,
            color: 'primary'
          })
        })
        .catch((error) => {
          console.log(error)
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            color: 'danger'
          })
        })
        .then(() => {
          // always executed
          this.popupActive = !this.popupActive
        })
    }
  }
})
</script>